// composables/usePauseTimer.js
import store from "@/store";

/**
 * Composable for managing pause timer functionality
 */
export default function usePauseTimer(durationInMinutes) {
  /**
   * Format date to time string
   * @param {Date} date - Date to format
   * @returns {String} Formatted time string
   */
  const formatTime = (date) =>
    date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

  /**
   * Start a new pause with the specified duration
   * @param {Object} pauseData - Dados da pausa, incluindo duration
   */
  const startPause = (pauseData) => {
    const now = new Date();
    // Utiliza a duração fornecida no payload ou um valor padrão de 15 minutos
    const pauseDuration = pauseData?.duration || durationInMinutes || 15;
    const end = new Date(now.getTime() + pauseDuration * 60000);

    updatePauseTimes({
      start: formatTime(now),
      end: formatTime(end),
    });
  };

  /**
   * Update pause times in the store
   * @param {Object} times - Object containing start and end times
   */
  const updatePauseTimes = (times) => {
    store.dispatch("setPauseTimes", times);
  };

  /**
   * Get pause start time from store
   */
  const getPauseStart = () => store.state.pauseStart;

  /**
   * Get pause end time from store
   */
  const getPauseEnd = () => store.state.pauseEnd;

  return {
    formatTime,
    startPause,
    updatePauseTimes,
    getPauseStart,
    getPauseEnd,
  };
}
